import React from "react";
import { Link } from "react-router-dom";

// Official brand lockup: "AR / American Rag". Do not rename the brand.
export const Logo = ({ className = "", dark = false }) => (
  <Link to="/" aria-label="AR / American Rag home" data-testid="logo-link" className={`inline-flex items-baseline gap-2 leading-none ${className}`}>
    <span className={`font-display font-bold tracking-tight ${dark ? "text-white" : "text-navy"}`}>AR</span>
    <span className={`font-display font-light ${dark ? "text-white/40" : "text-ink/30"}`}>/</span>
    <span className={`font-heading font-semibold uppercase tracking-[0.13em] ${dark ? "text-white/90" : "text-ink"}`} style={{ fontSize: "0.6em" }}>
      American&nbsp;Rag
    </span>
  </Link>
);
